import { z } from 'zod';
import { DateOfBirthSchema } from '../../../../form-controls/DateOfBirth/schema';
import { createFirstNameSchema, createLastNameSchema } from '../../../../form-controls/PersonName/schema';

const PersonalDetailsSchema = (t: (key: string) => string) =>
  z.object({
    firstName: createFirstNameSchema(t),
    lastName: createLastNameSchema(t),
    dateOfBirth: DateOfBirthSchema(t),
  });

export { PersonalDetailsSchema };
